import * as React from "react";

function SvgUsers(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width={21} height={21} {...props} viewBox="0 0 32 15">
        <path
          data-name="Path 43713"
          d="M14.349 12.574A4.67 4.67 0 109.63 7.856a4.726 4.726 0 004.718 4.718zm-.1-7.415a2.794 2.794 0 012.792 2.792 2.745 2.745 0 01-5.489 0 2.776 2.776 0 012.701-2.792z"
        />
        <path
          data-name="Path 43714"
          d="M28.601 11.997a9.535 9.535 0 00-6.744-2.408h-.77a6.417 6.417 0 01-.867 2.022 9.353 9.353 0 011.637-.1 8.012 8.012 0 015.1 1.541v6.934h1.926v-7.7z"
        />
        <path
          data-name="Path 43715"
          d="M19.646 3.426a2.352 2.352 0 112.215 3.275 1.641 1.641 0 01-.674-.1 6.832 6.832 0 01.1 1.349v.578c.192 0 .385.1.578.1a4.286 4.286 0 10.1-8.571 4.13 4.13 0 00-3.667 2.12 4.115 4.115 0 011.349 1.25z"
        />
        <path
          data-name="Path 43716"
          d="M8.667 11.708A6.425 6.425 0 017.8 9.686h-.77a9.909 9.909 0 00-6.741 2.312L0 12.287v7.7h1.926v-6.931a8.189 8.189 0 015.1-1.541 8.491 8.491 0 011.641.193z"
        />
        <path
          data-name="Path 43717"
          d="M7.03 8.53a1.225 1.225 0 00.578-.1v-.574a5.932 5.932 0 01.1-1.349 1.641 1.641 0 01-.674.1 2.312 2.312 0 110-4.623 2.434 2.434 0 012.212 1.441 9.56 9.56 0 011.445-1.349 4.278 4.278 0 10-3.66 6.452z"
        />
        <path
          data-name="Path 43718"
          d="M22.245 17.774l-.192-.289a9.721 9.721 0 00-7.512-3.274 9.92 9.92 0 00-7.611 3.275l-.192.289v7.318a1.623 1.623 0 001.637 1.637h12.329a1.688 1.688 0 001.637-1.637v-7.319zm-1.925 7.027H8.667v-6.353a8.218 8.218 0 015.874-2.311 7.768 7.768 0 015.778 2.311z"
        />
      </svg>
    </span>
  );
}

export default SvgUsers;
